import {
  Feature,
  FeatureCollection,
  GeoJsonProperties,
  Geometry,
} from 'geojson';
/**
 * Combines an array of features into a feature collection
 * @param features array of features to combine
 * @returns A feature collection
 */
export const createFeatureCollection = <T = GeoJsonProperties>(
  features: Feature<Geometry, T>[]
): FeatureCollection<Geometry, T> => {
  const featureCollection: FeatureCollection<Geometry, T> = {
    type: 'FeatureCollection',
    features: features,
  };
  return featureCollection;
};
